// extracted by mini-css-extract-plugin
export default {"container":"hOKC2f","small":"stYtc0","triangle":"WbJAED","top":"ozV0Nq"};